import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "invest-list" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  style: {"color":"green"}
}
const _hoisted_5 = {
  key: 2,
  style: {"color":"red"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("查看")

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";

      
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ustore = useStore();
      const loading = ref(true)
      const bindData = reactive({
      statusOptions: [
        {
          value: '',
          label: '全部状态',
        },
        {
          value: '0',
          label: '待审核',
        },
        {
          value: '2',
          label: '通过',
        },
        {
          value: '3',
          label: '拒绝',
        }
      ],
      pageParams: {
        curPage: 1,
        pageSize: 10,
        filtrate: {
          auditStatus: "",
          keyword: "",
          type:"2",
          projectId:'',
          activityId:''
        },
      },
      pageResult: {
        status: 2000,
        msg: "成功",
        result: [],
        totalCount: 0,
      },
      projects:[],
      activitys:[]
      });

      const handleSizeChangeEvent = (value: any) => {
      bindData.pageParams.pageSize = value;
      bindData.pageParams.curPage = 1;
      searchEvent();
    };

    const handleCurrentChangeEvent = (value: any) => {
      bindData.pageParams.curPage = value;
      searchEvent();
    };


      const searchEvent = () => {
        store
          .dispatch("communityModule/pageActivityApplyList", bindData.pageParams)
          .then(
            (data) => {
              console.log(data);
              //成功
              for (var index in data.result) {
                const obj = data.result[index];
                switch (obj.auditStatus) {
                  case 0:
                    obj.statusName = "待审核";
                    break;
                  case 1:
                    obj.statusName = "通过";
                    break;
                  case 2:
                    obj.statusName = "拒绝";
                    break;
                  default:
                    obj.statusName = "--";
                    break;
                }
              }
              bindData.pageResult = data;
              loading.value = false;
            },
            (error) => {
              console.log(error.msg);
            }
          );
    };

     const projectEvent = () => {
        store
          .dispatch("communityModule/listProject", bindData.pageParams)
          .then(
            (data) => {
              bindData.projects = data.result;
            },
            (error) => {
              console.log(error.msg);
            }
          );
    };
    const activityEvent = () => {
        const params = {
               type:2
        };
        store
          .dispatch("communityModule/listActivity",params)
          .then(
            (data) => {
              bindData.activitys = data.result;
            },
            (error) => {
              console.log(error.msg);
            }
          );
    };
    projectEvent();
    activityEvent();
    var toCommunityApplyDetail = (index: number, row: any) =>{
         var id = "add";
         if(row){
            id = row.id;
         }
         router.push("/middleGround/community/communityApplyList/communityApplyDetail/"+id);
    }

    const deleteEvent = (index: number, row: any) => {
      ElMessageBox.confirm(`您确定要删除 ${row.name} 吗?`)
        .then(() => {
          const params = {
            id: row.id,
          };
          store.dispatch("communityModule/deleteActivity", params).then(
            (data) => {
              //成功
              ElMessage.success("删除成功.");
              searchEvent();
            },
            (error) => {
              ElMessageBox.alert(error.msg, "系统消息", {
                confirmButtonText: "关闭",
                callback: (action: Action) => {},
              });
            }
          );
        })
        .catch(() => {
          // catch error
        });
    };


    searchEvent();



return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "invest-list-search" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, { class: "invest-list-search-lt" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { class: "invest-list-search-lt-text" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(bindData).pageParams.filtrate.auditStatus,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).pageParams.filtrate.auditStatus) = $event)),
                  size: "large",
                  placeholder: "请选择审核状态",
                  onChange: searchEvent
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).statusOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "invest-list-search-lt-text" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(bindData).pageParams.filtrate.projectId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).pageParams.filtrate.projectId) = $event)),
                  size: "large",
                  placeholder: "请选择项目",
                  onChange: searchEvent
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "全部项目",
                      value: ""
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).projects, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "invest-list-search-lt-text" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(bindData).pageParams.filtrate.activityId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).pageParams.filtrate.activityId) = $event)),
                  size: "large",
                  placeholder: "请选择活动",
                  onChange: searchEvent
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "全部活动",
                      value: ""
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).activitys, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "invest-list-search-lt-text" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "请输入申请人、手机号搜索",
                  modelValue: _unref(bindData).pageParams.filtrate.keyword,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).pageParams.filtrate.keyword) = $event)),
                  modelModifiers: { trim: true },
                  onKeyup: _withKeys(searchEvent, ["enter"]),
                  size: "large"
                }, null, 8, ["modelValue", "onKeyup"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "invest-list-search-lt-btn" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  type: "primary",
                  size: "large",
                  onClick: searchEvent
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_table, {
      data: _unref(bindData).pageResult.result,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "contact",
          label: "申请人",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "mobile",
          label: "电话",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "applyTime",
          label: "报名日期",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "memberTypeDesc",
          label: "会员类型",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          width: "180"
        }, {
          default: _withCtx((scope) => [
            (scope.row.auditStatus == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(scope.row.statusName), 1))
              : _createCommentVNode("", true),
            (scope.row.auditStatus == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(scope.row.statusName), 1))
              : _createCommentVNode("", true),
            (scope.row.auditStatus == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(scope.row.statusName), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "操作",
          width: "200"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_unref(ElButton), {
              type: "text",
              size: "small",
              onClick: ($event: any) => (_unref(toCommunityApplyDetail)(scope.$index, scope.row))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_container, { class: "account-page_toolbar" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_pagination, {
          currentPage: _unref(bindData).pageParams.curPage,
          "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((_unref(bindData).pageParams.curPage) = $event)),
          "page-size": _unref(bindData).pageParams.pageSize,
          "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => ((_unref(bindData).pageParams.pageSize) = $event)),
          "page-sizes": [10, 20, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _unref(bindData).pageResult.totalCount,
          "onUpdate:total": _cache[6] || (_cache[6] = ($event: any) => ((_unref(bindData).pageResult.totalCount) = $event)),
          onSizeChange: handleSizeChangeEvent,
          onCurrentChange: handleCurrentChangeEvent
        }, null, 8, ["currentPage", "page-size", "total"])
      ]),
      _: 1
    })
  ]))
}
}

})